export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_03.f8543bfa.mp4";